// components/layout/Layout.js
import React from 'react';
import Navbar from '../navbar/navbar'; // Assuming you have a Navbar component

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <div>{children}</div>
    </>
  );
};

export default Layout;
